module.exports = __webpack_public_path__ + "img/default.94e4d9c8.png";